export default __webpack_public_path__ + "static/media/3.a60a2f6f.mp4";